export const MOCK_PRODUCT_IMAGE_URL = `https://placehold.co/120x120?text=${encodeURIComponent("Personalized Content")}`;
export const MOCK_CUSTOM_FIELD = "Custom field";

export const MOCK_VARIANT_METAFIELDS: Record<string, string> = {
  Color: "red",
  Size: "large",
};
